import { type UnknownAction, combineReducers } from '@reduxjs/toolkit';
import { api } from '@shared/api/api';
import { apiBlob } from '@shared/api/api-blob';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { authActions, authReducer } from './ducks/auth';
import { appSettingsReducer } from './ducks/app-settings';
import { channelFormDraftsReducer } from './ducks/channel-form-drafts';
import { globalConfirmModalReducer } from './ducks/global-confirm-modal';
import { viewFiltersReducer } from './ducks/view/view-filters';
import { viewDashboardsReducer } from './ducks/view/view-dashboards';

const persistConfig = {
  key: 'consultant-app:root:v2',
  storage,
  whitelist: ['auth', 'appSettings', 'viewFilters'],
};

const rootReducer = combineReducers({
  [api.reducerPath]: api.reducer,
  [apiBlob.reducerPath]: apiBlob.reducer,
  auth: authReducer,
  appSettings: appSettingsReducer,
  channelFormDrafts: channelFormDraftsReducer,
  globalConfirmModal: globalConfirmModalReducer,
  viewFilters: viewFiltersReducer,
  viewDashboards: viewDashboardsReducer,
});

export const rootReducerWithLogout = (
  state: ReturnType<typeof rootReducer> | undefined,
  action: UnknownAction,
) => {
  if (action.type === authActions.logout.type) {
    const newState = rootReducer(undefined, action);
    const authState = authReducer(state?.auth, action);

    return {
      ...newState,
      auth: authState,
    };
  }

  return rootReducer(state, action);
};

const persistedReducer = persistReducer(persistConfig, rootReducerWithLogout);

export default persistedReducer;
